//* Necessary for typing in actions and getters.
/* eslint-disable @typescript-eslint/no-use-before-define, no-use-before-define */
//* We would like the errors to appear in the console if they happen.
/* eslint-disable no-console */

import { useFirestore } from '@/services';
import * as App from '@/types/app';
import * as Database from '@/types/database';
import { defineFirebaseCollectionStoreModule } from './base-module';

const { useAppDefaultOperators } = useFirestore();
export const appDefaultsModule = defineFirebaseCollectionStoreModule<App.AppDefaults, Database.AppDefaults>(
  useAppDefaultOperators
);
